import React from "react"
import Layout from "components/Layout"
import Button from "components/_ui/Button"
import styled from "@emotion/styled"

const ContactTitle = styled("h1")`
  margin-bottom: 1em;
`

export default () => {
  return (
    <Layout>
      <ContactTitle>Subscribe</ContactTitle>
      <form
        name="subscribe"
        method="post"
        data-netlify="true"
        data-netlify-honeypot="bot-field"
      >
        Get the latest updates and free learning resources.
        <br />
        <input type="hidden" name="form-name" value="subscribe" />
        {/* <Input
          name="name"
          id="name"
          placeholder="Name"
          style={{ width: 150 }}
        /> */}{" "}
        <input
          name="email"
          id="email"
          placeholder="Email"
          style={{
            width: 350,
            height: 50,
            fontSize: "18px",
            paddingLeft: "10px",
          }}
        />{" "}
        <Button>
          Subscribe to newsletter
        </Button>
      </form>
    </Layout>
  )
}
